import { render, staticRenderFns } from "./NewsEntry.vue?vue&type=template&id=47b0c089"
import script from "./NewsEntry.vue?vue&type=script&lang=js"
export * from "./NewsEntry.vue?vue&type=script&lang=js"
import style0 from "./NewsEntry.vue?vue&type=style&index=0&id=47b0c089&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports